import * as React from 'react';

import { Flex } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';

import { createReactRenderer } from 'helpers/react-renderer';

import SerializedRefundRow from './SerializedRefundRow';
import { SerializedItem, SerializedRefundProps } from './types';

const MAX_VERTICAL_SERIALS = 5;

const SerializedRefund: React.FC<SerializedRefundProps> = ({ serials, qout }) => {
  const [isContentExpanded, setIsContentExpanded] = React.useState(false);

  const shouldRenderExpander = qout > MAX_VERTICAL_SERIALS && !isContentExpanded;

  const renderSerializedItemInfo = () => {
    const remainingRenderRows = qout - MAX_VERTICAL_SERIALS;

    const msg = `serial number${remainingRenderRows > 1 ? 's' : ''}`;

    const expanderContent = (
      <TextLink
        data-test="expander-content"
        width="fit-content"
        mt={1}
        onClick={() => {
          setIsContentExpanded(true);
        }}
      >
        <var className="notranslate">
          {' '}
          &#43;
          {remainingRenderRows}{' '}
        </var>
        <span>{msg}</span>
      </TextLink>
    );

    const content = serials.map((serializedItem: SerializedItem) => {
      const { serial, colorName, sizeName, serializedId, isRefunded, isSelected } = serializedItem;
      return (
        <SerializedRefundRow
          serial={serial}
          colorName={colorName}
          sizeName={sizeName}
          serializedId={serializedId}
          isRefunded={isRefunded}
          isSelected={isSelected}
          key={`${serial}-${serializedId}`}
        />
      );
    });

    const emptySerials = new Array(qout - content.length).fill(0).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Text mt={1} key={index} data-test="serialized-refund-row-empty-serial">
        {' '}
        Serial: None
      </Text>
    ));

    const allSerials = [...content, ...emptySerials];

    const listToRender = isContentExpanded ? allSerials : allSerials.slice(0, MAX_VERTICAL_SERIALS);

    return (
      <>
        {listToRender}
        {shouldRenderExpander && expanderContent}
      </>
    );
  };

  return <Flex flexDirection="column">{renderSerializedItemInfo()}</Flex>;
};

export default SerializedRefund;

const RenderedComponent = createReactRenderer({
  component: SerializedRefund,
  selector: '[data-react-root="SerializedRefund"]',
});

history.onChangeState(
  [
    { pathname: '/register.php', form_name: undefined, view: undefined },
    { pathname: '/register.php', form_name: 'refund_mode' },
    { pathname: '/register.php', form_name: 'load_refund' },
    { pathname: '/register.php', form_name: 'change_view' },
    { form_name: 'refund_transaction_line' },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
